<div class="rounded p-2 mb-2"
     [ngClass]="{ 'border': groep?.id !== 'root', 'en-groep': groep?.operator === 'en', 'of-groep': groep?.operator === 'of' }">
    <div class="d-flex align-items-center mb-2">
        @if (groep.id !== 'root') {
            @switch (groep?.operator) {
                @case ('en') {
                    <span class="fas fa-layer-group text-info mr-2" title="EN-groep"></span>
                }
                @case ('of') {
                    <span class="fas fa-code-branch text-info mr-2" title="OF-groep"></span>
                }
            }
            <span class="badge badge-light mr-2">{{ groep?.operator?.toUpperCase() }}-groep</span>
        }
        @if (!groepIsGeldig(groep)) {
            <span class="fas fa-exclamation-triangle text-warning mr-2"
                  title="Deze groep bevat ongeldige voorwaarden"></span>
        }
        <small class="text-muted mr-auto">({{ groep?.kinderen?.length || 0 }} @if (groep?.kinderen.length === 1) {
            voorwaarde
        } @else {
            voorwaarden
        })</small>
        @if (groep.id !== 'root') {
            <button class="btn btn-outline-danger btn-sm" (click)="verwijderClausule.emit(groep.id)"
                    title="Verwijder groep">
                <span class="fas fa-trash"></span>
            </button>
        }
    </div>

    @if (groep?.kinderen?.length) {
        @for (kind of groep.kinderen; track kind.id; let i = $index) {
            @if (i > 0) {
                <span class="logische-sep">{{ groep.operator }}</span>
            }
            @switch (kind.soort) {
                @case ('regel') {
                    @switch (kind.regel.context) {
                        @case ('project') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-project-edit
                                        [regel]="kind.regel"
                                        [clausuleId]="kind.id"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-project-edit>
                            </div>
                        }
                        @case ('planitempersoneel') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-personeel-edit
                                        [regel]="$any(kind.regel)"
                                        [clausuleId]="kind.id"
                                        [dropdownContainer]="dropdownContainer"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-personeel-edit>
                            </div>
                        }
                        @case ('vrij') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-vrij-edit
                                        [regel]="kind.regel"
                                        [clausuleId]="kind.id"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-vrij-edit>
                            </div>
                        }
                        @case ('personeelslabel') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-personeelslabel-edit
                                        [regel]="$any(kind.regel)"
                                        [clausuleId]="kind.id"
                                        [dropdownContainer]="dropdownContainer"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-personeelslabel-edit>
                            </div>
                        }
                        @case ('planitemfunctie') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-functie-edit
                                        [regel]="$any(kind.regel)"
                                        [clausuleId]="kind.id"
                                        [dropdownContainer]="dropdownContainer"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-functie-edit>
                            </div>
                        }
                        @case ('planitemfunctionalias') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-functionalias-edit
                                        [regel]="$any(kind.regel)"
                                        [clausuleId]="kind.id"
                                        [dropdownContainer]="dropdownContainer"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-functionalias-edit>
                            </div>
                        }
                        @case ('planitemongekwalificeerd') {
                            <div class="d-flex align-items-center flex-wrap">
                                <filterregel-ongekwalificeerd-edit
                                        [regel]="$any(kind.regel)"
                                        [clausuleId]="kind.id"
                                        [isInRootGroep]="groep.id === 'root'"
                                        (wijzig)="wijzigRegel.emit($event)"
                                        (verwijder)="verwijderClausule.emit($event)"
                                        (uitDezeGroep)="verplaatsRegelNaarParent.emit($event)"
                                        (wikkelInEn)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'en'})"
                                        (wikkelInOf)="wikkelRegelInGroep.emit({clausuleId: $any(kind.id), operator: 'of'})"></filterregel-ongekwalificeerd-edit>
                            </div>
                        }
                    }
                }
                @case ('groep') {
                    <!-- Recursieve weergave -->
                    <filtergroep
                            [groep]="kind"
                            [dropdownContainer]="dropdownContainer"
                            (wijzigRegel)="wijzigRegel.emit($event)"
                            (verwijderClausule)="verwijderClausule.emit($event)"
                            (voegNieuweRegelToeInGroep)="voegNieuweRegelToeInGroep.emit($event)"
                            (verplaatsRegelNaarParent)="verplaatsRegelNaarParent.emit($event)"
                            (wikkelRegelInGroep)="wikkelRegelInGroep.emit($event)"></filtergroep>
                }
            }
        }
    }

    <!-- Toevoegen binnen deze groep -->
    <div class="row mt-2">
        <div class="col w-col-10">
            <ng-select
                    [(ngModel)]="nieuwRegelType"
                    [id]="'nieuwtype_' + groep.id"
                    name="nieuwtype_{{groep.id}}"
                    [searchable]="false"
                    [clearable]="false"
                    dropdownPosition="auto"
                    [appendTo]="dropdownContainer"
                    placeholder="Kies type">
                @for (type of regelTypes; track type) {
                    @if (!regelTypeNamen[type].uitgeschakeld) {
                        <ng-option [value]="type">{{ regelTypeNamen[type].label }}</ng-option>
                    }
                }
                <!-- visuele scheiding tussen gewone regels en speciale groep-opties -->
                <ng-option class="opt-separator" [disabled]="true" [value]="'__sep__'">—</ng-option>
                <ng-option value="--EN">EN-groep</ng-option>
                <ng-option value="--OF">OF-groep</ng-option>
            </ng-select>
        </div>
        <div class="col w-col-2">
            <button class="btn btn-outline-primary btn-sm mt-1 mt-md-0"
                    (click)="voegNieuweRegelToe()"
                    [disabled]="! nieuwRegelType"
                    title="Voeg regel toe in deze groep">
                <span class="fas fa-plus"></span>
            </button>
        </div>
    </div>
    @if (nieuwRegelType) {
        <div class="row mt-1">
            <div class="col w-col-12">
                <small class="text-muted">
                    @if (nieuwRegelType === '--EN') {
                        Voegt een EN-subgroep toe. Alle voorwaarden binnen deze subgroep moeten waar zijn.
                    } @else if (nieuwRegelType === '--OF') {
                        Voegt een OF-subgroep toe. Minstens één voorwaarde binnen deze subgroep moet waar zijn.
                    } @else {
                        {{ regelTypeNamen[$any(nieuwRegelType)].omschrijving }}
                    }
                </small>
            </div>
        </div>
    }
</div>
